<div
  class="text-text-secondary text-[12.5px] leading-[1.65]"
  [class]="
    framed() ? 'border-weak bg-surface max-h-40 overflow-y-auto border-t px-3 py-2' : ''
  "
  role="group"
  [attr.tabindex]="framed() ? 0 : null"
  [attr.aria-labelledby]="label() ? labelId : null">
  @if (label(); as key) {
    <span class="text-text-tertiary block text-[11.5px]" [id]="labelId">{{
      key | translate
    }}</span>
  }
  <p>
    @for (part of parts(); track $index) {
      <span
        class="g-phrase-part"
        [class.is-linked]="part.node !== null && part.node === hovered()"
        (mouseenter)="hovered.set(part.node)"
        (mouseleave)="hovered.set(null)">
        @for (segment of part.segments; track $index) {
          <span [class]="ROLE_CLASSES[segment.role]" [textContent]="segment.text"></span>
        }
      </span>
    }
  </p>
</div>
